import React, { useEffect } from 'react'

const PatientQuestionPoa = ({ diagnosisName, noteStructureRef, questionValue }) => {
  // const formatKey = (key) => {
  //   const spaced = key.replace(/([a-z])([A-Z])/g, "$1 $2");
  //   return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  // };

  // const formattedData = submission?.diagnosis
  //   ? submission.data.flatMap(item =>
  //     Object.entries(item).map(([key, value]) => ({
  //       question: formatKey(key),
  //       answer: value
  //     }))
  //   )
  //   : [];

  // noteStructureRef.current = {
  //   ...noteStructureRef.current,
  //   poa: {
  //     ...noteStructureRef.current.poa,
  //     [diagnosisName]: formattedData
  //   }
  // }
  // return null

  const formattedData =
    questionValue?.[diagnosisName]?.map((item) => ({
      question: item.question,
      answer: item.answer,
      freeType: item.freeType || '',
    })) || []

  useEffect(() => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      poa: {
        ...noteStructureRef.current.poa,
        [diagnosisName]: formattedData,
      },
    }
  }, [formattedData, diagnosisName, noteStructureRef])

  return null
}

export default PatientQuestionPoa
